import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ClerkProvider } from '@clerk/clerk-react';
import { clerkConfig } from './config/clerk.config';

// Import the Clerk publishable key from environment
const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || clerkConfig.publishableKey;

if (!clerkPubKey) {
  console.error('Missing REACT_APP_CLERK_PUBLISHABLE_KEY in .env file');
}

// NOTE: If you experience redirects to Vercel/production URLs when accessing localhost,
// this is likely due to browser caching. Try:
// 1. Hard refresh (Cmd+Shift+R / Ctrl+Shift+R)
// 2. Clear browser cache and cookies for localhost
// 3. Use incognito/private browsing mode
// 4. Clear Clerk session cookies (they may be tied to the production domain)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider 
      publishableKey={clerkPubKey}
      {...clerkConfig}
    >
      <App />
    </ClerkProvider>
  </React.StrictMode>
);
